<div class="reschedule-order-wrapper">
  <h2>Change Next Order Date</h2>

  <h3>
    Next Order Date:
    {{ nextOccurrenceUtc | dateFormat: "MMM d, YYYY" : siteSettings.utcOffset }}
  </h3>

  @if (dateInThePast) {
    <p>
      Your {{ orderVerboseName }} was scheduled to process on date
      {{
        nextOccurrenceUtc | dateFormat: "MMM d, YYYY" : siteSettings.utcOffset
      }}, which is in the past.
    </p>
    <p>Please select a new date for your {{ orderVerboseName }}:</p>
  }

  <div class="field-with-left-icon">
    <md-icon>calendar_month</md-icon>
    <lib-nod-date-picker
      [date]="date"
      [config]="config"
      (dateChanged)="onDateChanged($event)"
    />
  </div>

  <div class="action-buttons">
    <md-outlined-button (click)="onCancel()">Cancel</md-outlined-button>
    <md-filled-button (click)="onConfirm()">{{
      confirmButtonText
    }}</md-filled-button>
  </div>
</div>
